export const kpiDisplayValues = {
    kpi: "KPI",
    spekwoKpi: {
        title: "spekwo KPI",
        save: "SAVE",
        tableHeads: {
          sales: "SALES",
          itemRev: "Item Rev",
          grossRev: "Gross Rev",
          marketing: "MARKETING",
          quantityOrCost: "Quantity/Cost"
        },
    
        kpiFieldsName: {
          spekOrdered: "speKwo's Ordered",
          spekApproved: "speKwo approved",
          spekWalkOrdered: "SpeK-walk Ordered",
          spekCallOrdered: "SpeK-call ordered",
          revenueForSpekPro: "Revenue generate for spekwo Pro",
          revenueForSpekInternalPro: "Revenue generated for spekwo Internal Pro",
          ouboundCalls: "# of outbound calls",
          emailCapaigns: "# of email campaigns",
          livePresentation: "Amount spent on Live presentations",
          amtSpenForFb: "Amount spent on FB",
          amtSpenForInsta: "Amount spent on InstaGram",
          amtSpenForLinkedIn: "Amount spent on LinkedIn"
        },
        kpiToolTips: {
          nextMonth: "Click to view next month KPI values",
          prevMonth: "Click to view previous month KPI values"
        },

        kpiSheetValues:{
          sheetTitle:"spekwo KPI Details",
        },
    
        monthNames: ["January", "February", "March", "April", "May", "June",
          "July", "August", "September", "October", "November", "December"
        ]
    
      },
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/utils/e-commerce/kpi.ts